<template>
  <div class="text-left px-6 pb-12 bg-gray-50 h-screen">
    <div class="absolute mt-11" @click="back">
      <back-arrow-icon :width="'w-4'" :height="'h-4'"></back-arrow-icon>
    </div>
    <div class="text-center text-sm font-extrabold w-full pt-12">CONTACT US</div>
    <div class="pt-14">
      <div class="rounded-2xl shadow-nw pl-4 xxs:pl-7 pr-2 py-6 flex">
        <div>
          <call-us-icon></call-us-icon>
        </div>
        <div class="pl-4 xxs:pl-8 pt-0">
          <div class="text-xs font-bold">CALL US</div>
          <div class="text-xs capitalize text-nw-red font-bold py-px">
            <a href="tel:09138436268">Abuja - 0913 843 6268</a>
          </div>
          <div class="text-xs capitalize text-nw-red font-bold py-px">
            <a href="tel:09134846692">Lagos - 0913 484 6692</a>
          </div>
          <div class="text-xs capitalize text-nw-red font-bold py-px">
            <a href="tel:09139117049">PH City - 0913 911 7049</a>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-10">
      <div class="rounded-2xl shadow-nw pl-4 xxs:pl-7 pr-2 py-6 flex">
        <a href="mailto:support@northwinglogistics.com">
          <contact-email-icon></contact-email-icon>
        </a>
        <div class="pl-4 xxs:pl-8 pt-3">
          <div class="text-xs font-bold">EMAIL US</div>
          <div class="text-nw-red font-bold text-xs">
            <a href="mailto:support@northwinglogistics.com">support@northwinglogistics.com</a>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-10">
      <div class="rounded-2xl shadow-nw pl-4 xxs:pl-7 pr-2 py-6 flex">
        <a href="https://northwinglogistics.com" target="_blank">
          <web-icon></web-icon>
        </a>
        <div class="pl-4 xxs:pl-8 pt-3">
          <div class="text-xs font-bold">VISIT US</div>
          <div class="text-nw-red font-bold text-xs">
            <a href="https://northwinglogistics.com" target="_blank">northwinglogistics.com</a>
          </div>
        </div>
      </div>
    </div>
    <div class="py-10 w-11/12 xxs:w-3/4 xs:w-2/3 mx-auto">
      <div class="flex items-center justify-between">
        <div class="rounded-lg shadow-md w-full mr-2">
          <div class="mx-auto w-1/2 md:w-1/3 py-4 flex items-center justify-center">
            <a href="https://web.facebook.com/northwinglogistics" target="_blank">
              <facebook-icon></facebook-icon>
            </a>
          </div>
        </div>
        <div class="rounded-lg shadow-md w-full mr-2">
          <div class="mx-auto w-1/2 md:w-1/3 py-4 flex items-center justify-center">
            <a href="https://www.instagram.com/northwinglogistics/" target="_blank">
              <instagram-icon></instagram-icon>
            </a>
          </div>
        </div>
        <div class="rounded-lg shadow-md w-full">
          <div class="mx-auto w-1/2 md:w-1/3 py-4 flex items-center justify-center">
            <a href="https://www.twitter.com/" target="_blank">
              <twitter-icon></twitter-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackArrowIcon from '@/components/icons/BackArrowIcon.vue'
import CallUsIcon from '../components/icons/CallUsIcon.vue'
import ContactEmailIcon from '../components/icons/ContactEmailIcon.vue'
import WebIcon from '../components/icons/WebIcon.vue'
import FacebookIcon from '../components/icons/FacebookIcon.vue'
import InstagramIcon from '../components/icons/InstagramIcon.vue'
import TwitterIcon from '../components/icons/TwitterIcon.vue'
export default {
  components: {
    BackArrowIcon,
    CallUsIcon,
    ContactEmailIcon,
    WebIcon,
    FacebookIcon,
    InstagramIcon,
    TwitterIcon
  },
  data() {
    return {
      promo_code: '',
      payment_type: {
        pick_up: false,
        delivery: false,
        card: false
      }
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'Dashboard'
      })
    }
  },
  mounted() {
    this.$store.dispatch('middleware/isLoggedIn')
  }
}
</script>

<style></style>
